import React from 'react'

class ExpandingInfo extends React.Component {
  state = {
    expanded: false,
  };
  handleExpand = () => {
    this.setState({
      expanded: true
    });
  };
  render() {
    const { isDreamSpace } = this.props;
    const className = isDreamSpace ? 'dreamspace' : '';

    return (
      <div className={`expanding-info ${className}`}>
        <div className="expanding-info__lead">
          {this.props.lead}
        </div>
        <div className={`expanding-info__content ${this.state.expanded && 'expanded'}`}>
          <p className="expanding-info__how-does-it-work">How does it work:</p>
          {this.props.children}
        </div>
        <button
          onClick={this.handleExpand}
          className={`expanding-info__expand ${this.state.expanded && 'hidden'} ${className}`
          }>
          &#43; continue reading
        </button>
      </div>
    )
  }
}

export default ExpandingInfo;
